import { HttpParams } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { DynamicFieldModel } from '@share';
import { DynamicTableComponent } from 'src/app/share/dynamic-table/dynamic-table.component';
import { LoadingService } from 'src/app/share/services/loading.service';
import { SubcategoryService } from './subcategory.service';
import { NzModalService } from 'ng-zorro-antd/modal';
import { filter, forkJoin } from 'rxjs';
import { FilterTriggerConfig } from 'ng-zorro-antd/core/config';

@Component({
  selector: 'app-subcategory',
  imports: [DynamicTableComponent],
  templateUrl: './subcategory.component.html',
  styleUrl: './subcategory.component.scss'
})
export class SubcategoryComponent implements OnInit {
  total = 0;
  list: any[] = [];
  schema = {
    name: "Item-Category List",
    permissionKey: "subcategory",
    enableDelete: true,
    enableEdit: true,
    enableAdd: true,
    size: "middle",
    pageSize: 10,
    pageIndex: 1,
    sorts: {},
    columns: [
      {
        key: "serialNo",
        title: "No",
        type: "autoGenerate",
        width: "40px",
        isStickyRight: true,
        isStickyLeft: false,

      },
      {
        key: "group_name",
        title: "Group Name",
        type: "string",
        enableSearch: true,
        searchType: "select",
        option: [] as any[],
        width: "220px",
        isStickyRight: false,
        isStickyLeft: false,
      },
      {
        key: "maincategory_name",
        title: "Main Category Name",
        type: "string",
        enableSearch: true,
        searchType: "select",
        options: [] as any[],
        width: "260px",
        isStickyRight: false,
        isStickyLeft: false,
      },
      {
        key: "category_name",
        title: "Category Name",
        type: "string",
        enableSearch: true,
        searchType: "select",
        option: [] as any[],
        width: "260px",
        isStickyRight: false,
        isStickyLeft: false,
      },
      {
        key: "subcategory_name",
        title: "Item Category Name",
        type: "string",
        enableSearch: true,
        searchType: "select",
        option: [] as any[],
        width: "260px",
        isStickyRight: false,
        isStickyLeft: false,
      },
      {
        key: "action",
        title: "Actions",
        width: "150px",
        type: "button",
        isStickyRight: true,
        isStickyLeft: false,
        label: [{ name: "edit", type: "edit", isDanger: false, isEnable: true }, { name: "delete", type: "danger", isEnable: true }]//,{name:"delete",type:"danger"}
      }
    ]
  };

  fieldConfig: Array<DynamicFieldModel> = [

    {
      label: 'Group Name',
      name: 'group_id',
      type: 'select',
      required: true,
      placeholder: 'Group Name',
      optionUrl: 'categoryhierarchy/option',
      options: [
      ],
      validations: [
        {
          name: 'required',
          validator: Validators.required,
          message: 'Group Name required',
        },
      ],
    },
    {
      label: 'Main Category Name',
      name: 'maincategory_id',
      type: 'select',
      required: true,
      placeholder: 'Main Category Name',
      dependOn: 'group_id',
      matchType: 'Item',
      optionUrl: 'categoryhierarchy/option',
      options: [
      ],
      validations: [
        {
          name: 'required',
          validator: Validators.required,
          message: 'Main Category Name required',
        },
      ],
    },
    {
      label: 'Category Name',
      name: 'parent',
      type: 'select',
      required: true,
      placeholder: 'Category Name',
      dependOn: 'maincategory_id',
      optionUrl: 'categoryhierarchy/option',
      options: [
      ],
      validations: [
        {
          name: 'required',
          validator: Validators.required,
          message: 'Category Name required',
        },
      ],
    },
    {
      label: 'Name',
      name: 'name',
      type: 'input',
      placeholder: '',
      required: true,
      autofocus: true,
      validations: [
        {
          name: 'required',
          validator: Validators.required,
          message: 'Name required',
        },
      ],
    },

    {
      label: 'id',
      name: 'id',
      type: 'hidden',
      placeholder: ''
    },
  ];

  constructor(private readonly modalService: NzModalService, private readonly loadingService: LoadingService, private readonly service: SubcategoryService, private readonly cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    forkJoin({
      groups: this.service.getGroupOption(),
      maincategories: this.service.getMainCategoryItems(),
      categories: this.service.getCategoryItems(),
      subcategories: this.service.getItems()
    })
      .subscribe({
        next: ({ groups, maincategories, categories, subcategories }) => {
          this.schema.columns[1].option = groups?.map((y: any) => ({
            text: y.name,
            value: y.name
          }));

          this.schema.columns[2].option = maincategories?.data
            ?.filter((y: any) => y.type === 'Item')
            .map((y: any) => ({
              text: y.maincategory_name,
              value: y.maincategory_name
            }));

          this.schema.columns[3].option = categories?.data
            ?.filter((y: any) => y.type === 'Item')
            .map((y: any) => ({
              text: y.category_name,
              value: y.category_name
            }));

          this.schema.columns[4].option = subcategories?.data
            ?.filter((y: any) => y.type === 'Item')
            .map((y: any) => ({
              text: y.subcategory_name,
              value: y.subcategory_name
            }));

          this.fieldConfig[0].options = groups?.map((y: any) => ({
            type: y.type,
            text: y.name,
            value: y.id,
          }));
        },
        error: err => console.error('Error loading options:', err),
        complete: () => {
          let params = new HttpParams()
            .set('page', this.schema.pageIndex.toString())
            .set('pageSize', this.schema.pageSize.toString());
          this.loadData(params);
        }
      });
  }

  change(data: { [key: string]: any }) {
    let params = new HttpParams()
      //.set('searchValue',this.searchValue)
      .set('page', data['pageIndex'].toString())
      .set('pageSize', data['pageSize'].toString())
      .set('filterValue', JSON.stringify(data['filters']))
      .set('sort', JSON.stringify(data['sorts']))
    this.loadData(params);
  }

  loadData(param: HttpParams = null) {
    this.loadingService.toggleTableLoading();
    this.cdr.detectChanges();
    // let queryParams = param ? param : new HttpParams();
    // queryParams = queryParams.set('type', 'Item');

    this.service.getItems(param).subscribe({
      next: x => {
        this.list = x.data;
        this.total = x.total;
      },
      error: err => {
        this.loadingService.toggleTableLoading();
        this.cdr.detectChanges();
      },
      complete: () => {
        this.loadingService.toggleTableLoading();
        this.cdr.detectChanges();
      }
    });
  }
  formEvent(data: any) {
    const payload = { ...data, type: 'Item' };
    if (data.id) {
      this.service.updateItem(payload).subscribe(x => {
        let params = new HttpParams()
          .set('page', this.schema.pageIndex.toString())
          .set('pageSize', this.schema.pageSize.toString());
        this.loadData(params);
      });
    }
    else if (data.deleted_id) {
      this.modalService.confirm({
        nzTitle: 'Are you sure want to delete?',
        nzContent: 'This action cannot be undone.',
        nzOkText: 'Yes',
        nzCancelText: 'No',
        nzOnOk: () => {
          this.service.deleteItem(data).subscribe(x => {
            let params = new HttpParams()
              .set('page', this.schema.pageIndex.toString())
              .set('pageSize', this.schema.pageSize.toString());
            this.loadData(params);
          });
        },
        nzOnCancel: () => {

        }
      });

    }
    else {

      this.service.createItem(payload).subscribe(x => {
        let params = new HttpParams()
          .set('page', this.schema.pageIndex.toString())
          .set('pageSize', this.schema.pageSize.toString());
        this.loadData(params);
      });
    }
  }
}
